import React, { useEffect, useState } from "react";
import animateCss from "../../utils";
import "./index.scss";

class BannerLoading extends React.Component {
    ref = React.createRef()
    componentDidMount() {
        setTimeout(()=>{
            this.ref.current.style.visibility = "visible"
            this.ref.current.style.width = document.getElementById(this.props.el).offsetWidth + "px"
            animateCss(this.ref.current, "slideInLeft")
            .then(() => {
                this.props.show && this.props.show()
                document.getElementById(this.props.el).style.visibility = "visible"
                animateCss(this.ref.current, "slideOutRight")
                .then(()=>{
                    this.ref.current.style.visibility = "hidden"
                    this.ref.current.classList.remove("animate__animated")
                    this.ref.current.classList.remove("animate__slideOutRight")
                })
            })
        }, this.props.delay)
    }
    render() {
        return <div className="banner-info-mask animate__fast" style={{ visibility: "hidden", background: this.props.background || "#fff" }} ref={this.ref}></div>
    }
}

export default BannerLoading;